<template>
  <svg viewBox="5 5 40 40">
    <g style="display: inline">
      <line class="st0" x1="39.51" y1="21.12" x2="39.51" y2="40.64" />
      <polyline class="st0" points="42.01,22.73 25.29,9.9 8.26,22.98 	" />
      <line class="st0" x1="11.1" y1="40.64" x2="11.1" y2="21" />
      <line class="st0" x1="6.2" y1="40.64" x2="44.34" y2="40.64" />
      <path class="st0" d="M26.95,15.88" />
      <path class="st0" d="M29.69,15.88" />
      <polyline
        class="st0"
        points="13.59,18.67 13.59,10.66 18.03,10.66 18.03,15.37 	"
      />
    </g>
    <g style="display: inline">
      <path
        class="st0"
        d="M26.25,21.32c0,0-3.79,5.95-3.78,5.96c0,0,4.88-0.32,4.88-0.32l-3.03,4.36"
      />
    </g>
    <path
      style="
        display: inline;
        fill: none;
        stroke: #000000;
        stroke-miterlimit: 10;
      "
      d="M20.37,34.73c-2.33-1.6-3.86-4.28-3.86-7.32
	c0-2.12,0.74-4.07,1.98-5.59"
    />
    <path
      style="
        display: inline;
        fill: none;
        stroke: #000000;
        stroke-miterlimit: 10;
      "
      d="M34.27,27.41c0,4.9-3.97,8.88-8.88,8.88
	c-1.23,0-2.39-0.25-3.45-0.7"
    />
    <path
      style="
        display: inline;
        fill: none;
        stroke: #000000;
        stroke-miterlimit: 10;
      "
      d="M19.9,20.44c1.51-1.19,3.42-1.9,5.49-1.9
	c4.22,0,7.76,2.95,8.65,6.9"
    />
    <polyline
      style="
        display: inline;
        fill: none;
        stroke: #000000;
        stroke-miterlimit: 10;
      "
      points="15.87,22.29 18.6,21.71 18.95,24.49 "
    />
    <polyline
      style="
        display: inline;
        fill: none;
        stroke: #000000;
        stroke-miterlimit: 10;
      "
      points="35.26,23.06 34.04,25.56 31.63,24.13 "
    />
    <polyline
      style="
        display: inline;
        fill: none;
        stroke: #000000;
        stroke-miterlimit: 10;
      "
      points="23.29,38.01 21.91,35.6 24.44,34.4 "
    />
    <polyline
      style="
        display: inline;
        fill: none;
        stroke: #000000;
        stroke-miterlimit: 10;
      "
      points="26.75,31.17 24.03,31.76 23.65,28.99 "
    />
  </svg>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class IconZelfgebruikAlgemeen extends Vue {}
</script>

<style scoped type="text/css">
.st0 {
  fill: none;
  stroke: #000000;
  stroke-miterlimit: 10;
}
</style>
